module.exports = __webpack_public_path__ + "static/media/damekSchool.f67e01e1.jpg";